import styled from 'styled-components';
import Modal from '../Modal'; 

export const StyledModal = styled(Modal)`
  .modal-body {
    padding: 0; 
  }
  #btn-close-modal {
    display: none !important; 
  }
`;

export const NotificationWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 20px; 
  background-color: #f8f9fa; 
`;

export const IconWrapper = styled.div`
  margin-right: 15px; 
  display: flex;
  align-items: center;
`;

export const MessageWrapper = styled.div`
  flex-grow: 1; 
  p {
    margin: 0; 
    line-height: 1.4;
  }
`;

export const CloseIconWrapper = styled.div`
  margin-left: 15px; 
  cursor: pointer;
  display: flex;
  align-items: center;
`; 